export default class ItemSlider {
  constructor($el, config = { }) {
    this.$el = $el;
    this.config = {
      classes: {
        items: 'item-slider__items',
        item: 'item-slider__item',
        buttonPrev: 'item-slider__button--prev',
        buttonNext: 'item-slider__button--next',
      },
      ...config,
    };

    this.init();
  }

  init() {
    this.$items = this.$el.querySelector(`.${this.config.classes.items}`);
    this.$prev = this.$el.querySelector(`.${this.config.classes.buttonPrev}`);
    this.$next = this.$el.querySelector(`.${this.config.classes.buttonNext}`);
    this.$item = this.$el.querySelector(`.${this.config.classes.item}`);

    this.$prev.addEventListener('click', this.previous.bind(this));
    this.$next.addEventListener('click', this.next.bind(this));
    this.$items.addEventListener('scroll', this.onscroll.bind(this), { passive: true });
  }

  onscroll() {
    const {
      scrollLeft,
      firstElementChild,
      lastElementChild,
      scrollWidth,
      clientWidth,
    } = this.$items;

    const visibleItems = Math.ceil((clientWidth - 270) / firstElementChild.clientWidth);
    const PrevDisabled = scrollLeft < firstElementChild.clientWidth / 2;
    const NextDisabled = scrollLeft >= scrollWidth
      - visibleItems * (60 + lastElementChild.clientWidth);

    this.$prev.disabled = PrevDisabled;
    this.$next.disabled = NextDisabled;
  }

  next() {
    this.$items.scrollBy(375, 0);
  }

  previous() {
    this.$items.scrollBy(-375, 0);
  }
}

document.querySelectorAll('.js-item-slider').forEach(
  ($itemSlider) => {
    window.itemSlider = new ItemSlider($itemSlider);
  },
);
